// extracted by mini-css-extract-plugin
module.exports = {"image":"profile-list-module--image--1_Pwj"};